/* global modForm */
import {
	populateFormWithZipData,
	populateLocationFieldsDynamically,
	getConsentListing
} from '../../../helpers';
import { isZipCodeValid } from '../../../validators';
/**
 * Track second zip change and validate on the go
 * @returns {boolean} - false if no zip1Field is found
 */
export function initTrackZip1Change() {
	if (!modForm.opts.zip1Field.length) {
		return false;
	}

	let previousZip;
	let isValidating = false;

	modForm.opts.zip1Field.forEach(function(zip1Field) {
		zip1Field.addEventListener('keyup', function(e) {
			const $input = this;
			const shouldValidateZip = this.value.length === 5 && this.value !== previousZip && !isValidating && e.key !== 'Enter';
			if (shouldValidateZip) {
				previousZip = this.value;
				modForm.retryZipValidation = true;
				isValidating = true;
				isZipCodeValid($input.value, function(response) {
					isValidating = false;
					if (response.success) {
						if (response.data) {
							populateFormWithZipData(response.data);
							populateLocationFieldsDynamically(response.data);
						}
						// update the previous zip value if edited zip is valid
						previousZip = $input.value;
						$input.closest('.form-group').classList.remove(modForm.opts.fieldErrorCls);
						modForm.opts.zipCode = response.data.zip;

						// If we're currently fetching live consent listing in the page, fetch it one more time with an updated zipcode
						if (modForm.opts.gettingLiveConsent) {
							getConsentListing(modForm.opts.getConsentListingCallback);
						}

						// Fire callback
						if ('function' === typeof modForm.opts.zip1FieldValidated) {
							modForm.opts.zip1FieldValidated(response.data);
						}
					} else {
						$input.closest('.form-group').classList.add(modForm.opts.fieldErrorCls);
					}
				}, true, function() {
					isValidating = false;
				});
			}
		});
	});
}
